import React from 'react';
import styled from 'styled-components';

import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { CommonContainerStyle } from '../../styles';
import { WeatherConditionsInfoLoadingUI } from './weatherConditionsInfoLoadingUI';

export const CardBodyTopSectionLoadingUI = () => {
    return (
        <Container>
            <WeatherConditionsInfoLoadingUI />
            <DescriptionContainer>
                <AnimatedLoadingPlaceholder key='card-description-animated-loading-ui-0' width={97} height='27%' />
                <AnimatedLoadingPlaceholder key='card-description-animated-loading-ui-1' width={57} height='27%' />
                <AnimatedLoadingPlaceholder key='card-description-animated-loading-ui-2' width={77} height='27%' />
            </DescriptionContainer>
        </Container>
    );
};

const Container = styled.div`
    ${CommonContainerStyle}
    height: 142px;
    padding: 15px 15px 0 15px;
`;

const DescriptionContainer = styled.div`
    ${CommonContainerStyle}
    flex-direction: column;
    margin-top: 13px;
    min-height: 40px;
    height: 50%;
    justify-content: space-around;
    align-items: center;
`;